import React, { useState, useEffect } from 'react';
import HeartOutlined from '../Icons/HeartOutlined';
import HeartFilled from '../Icons/HeartFilled';
import IconButton from '../IconButton/IconButton';
import logger from '../../utils/logger';

function LikeButton({ isLiked, onLike, onUnlike, likeCount }) {
  const [optimisticState, setOptimisticState] = useState({
    isLiked: isLiked,
    likeCount: likeCount || 0,
  });

  useEffect(() => {
    setOptimisticState({ isLiked, likeCount: likeCount || 0 });
  }, [isLiked, likeCount]);

  const handleClick = async (e) => {
    e.preventDefault();
    const newIsLiked = !optimisticState.isLiked;
    const newLikeCount = newIsLiked
      ? optimisticState.likeCount + 1
      : optimisticState.likeCount - 1;

    setOptimisticState({ isLiked: newIsLiked, likeCount: newLikeCount });

    try {
      if (newIsLiked) {
        await onLike();
      } else {
        await onUnlike();
      }
    } catch (error) {
      logger.error('Error updating like status:', error);
      setOptimisticState({ isLiked, likeCount: likeCount || 0 });
    }
  };

  return (
    <IconButton
      count={optimisticState.likeCount}
      icon={optimisticState.isLiked ? <HeartFilled /> : <HeartOutlined />}
      onClick={handleClick}
      aria-label={optimisticState.isLiked ? 'Unlike' : 'Like'}
    />
  );
}

export default LikeButton;
